import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/terminalUiVersion/importer/versionImporterActions';

export default importerReducers(actions);
